import axios from "axios";

$(document).on("contact-us:section:main", function () {
    if ($("#section-contact-main").length > 0) {
        initContactMain();
    }

    $('#captcha-refresh').on('click', async function() {
        var captcha = $('img.captcha-img');
        let route = $(this).data('route');
        try {
            let response = await axios.get(route);
            captcha.prop('src', response.data);
        } catch (error) {
            console.error("error", error);
        }
    });
});

function initContactMain() {
    let swiper = new Swiper(".swiper-contact-us", {
        slidesPerView: 3,
        spaceBetween: 40,
        speed: 800,
        parallax: true,
        autoplay: {
            delay: 2000,
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
                spaceBetween: 20,
            },
            992: {
                slidesPerView: 3,
                spaceBetween: 40,
            },
        },
    });

    let tl = gsap.timeline();

    tl.fromTo(".contact-us-item-left", {
        x: 200,
        opacity: 0,
    }, {
        x: 0,
        opacity: 1,
        duration: 0.5,
    });

    tl.fromTo(".contact-us-item-middle", {
        x: 0,
        opacity: 0,
    }, {
        x: 0,
        opacity: 1,
        duration: 0.5,
    }, "<");

    tl.fromTo(".contact-us-item-right", {
        x: -200,
        opacity: 0,
    }, {
        x: 0,
        opacity: 1,
        duration: 0.5,
    }, "<");

    tl.to("#section-map", {
        scrollTrigger: {
            trigger: "#section-map",
            start: "top center",
            end: "bottom top",
            // toggleActions: 'play none none none',
            onEnter: toggleFunc,
        },
    });

    function toggleFunc() {
        $(".section-map").addClass("animation");
    }

}
